import { formatDateForFilename } from "@dana/Common/utils";
import { SalseOrgDetails } from "@dana/Services/StandardReturnDetailsService";
import { BackorderResponse, CancelOrderRequest, CancelValidationResponse, InvoiceDetailsResponse, OrderDetailEmail, OrderPackingSlip, OrderStatusResponse } from "@dana/Types/ApiModels";
import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

const apiUri = "/api/v2/dana/getDanaPackingSlip";
const apiUriInvoice = "/api/v2/dana/getDanaInvoice";
const apipacking = "/api/v2/dana/sendpayslipemail";
const apiInvoiceEmail = "/api/v2/dana/sendinvoiceemail";
const apiOrderDetailsEmail = "/api/v2/dana/sendorderdetailsemail";
const apiOpenorder = "/api/v2/dana/getOpenOrders";
const apiOpenorderDetail = "/api/v2/dana/getOpenOrderDetail";
const apiCancelLines = "/api/v2/dana/postcancellines";
const apiExportOpenOrder = "/api/v2/dana/getOpenOrdersExport";
const apideliveryNum = "/api/v2/dana/getDeliveryNumbers";
const apiResubmitOrder = "/api/v2/dana/resubmitOrderNumberToErp";
const apiordersRemoved = "/api/v2/dana/ordersRemoved";
const apiordersFailedRemoved = "/api/v2/dana/ordersmovedFailed";
const apiTrackingUri = "/api/v2/dana/getOrderStatus";

export interface InvoiceDetailsResult extends BaseModel {
  invoiceDetails: InvoiceDetailsResponse;
  salseOrgDetails: SalseOrgDetails;
}

export interface ShippingTrackingResult extends BaseModel{
    orderStatusResponse: OrderStatusResponse;
}
export interface DanaPackingSlipResult extends BaseModel {
  packingSlipDetails: OrderPackingSlip;
  salseOrgDetails: SalseOrgDetails;
}
export interface RequestSlipNumberApi extends ApiParameter {
    requestNumber?: string,
}

export interface RequestInvoiceApi extends ApiParameter {
    requestNumber?: string,
    requestType?: string,
}

export interface ShippingTrackingApi extends ApiParameter {
    orderNumber?: string,    
}

export interface DanaSendPayslipEmailApiParameter extends ApiParameter {
    recipientEmailAddress?: string;
    orderPackingSlipResponse?: OrderPackingSlip;
    packingHtml: string;
}

export interface DanaSendInvoiceTypeEmailApiParameter extends ApiParameter {
    recipientEmailAddress?: string;
    orderPackingSlipResponse?: InvoiceDetailsResponse;
    packingHtml: string;
    invoiceType: string;
}
export interface DanaSendOrderDetailsEmailApiParameter extends ApiParameter {
    recipientEmailAddress?: string;
    orderPackingSlipResponse?: OrderDetailEmail;
    packingHtml: string;
    invoiceType: string;
}

export interface OpenOrdersApiParameter extends ApiParameter {
    customerNumber?: string;
}

export interface OpenOrdersDetailsApiParameter extends ApiParameter {
    orderNumber?: string;
    poNumber?: string;
}
export interface PostCancelLinesApiParameter extends ApiParameter {
    cancelOrderRequest?: CancelOrderRequest;
}

export interface OpenOrderExportApiParameter extends ApiParameter {
    salesOrderNumber?: string;
    partNumber?: string;
    poNumber?: string;
    secondryPO?: string;
}

export interface GetDeliveryNumberApiParameter extends ApiParameter {
    orderNumber?: string;
}

export interface ResubmitOrderApiParameter extends ApiParameter {
    orderNumber?: string;
}

export interface RemovedOrdesApiParameter extends ApiParameter {
    orderNumber: string;
}

export interface MovedOrdesFailedApiParameter extends ApiParameter {
    orderNumber: string;
}

export async function getDanaPackingSlipNumber(parameter: RequestSlipNumberApi) {
    const result = await get<DanaPackingSlipResult>(`${apiUri}`, parameter);
    return result;
}

export async function getDanaInvoice(parameter: RequestInvoiceApi) {
    const result = await get<InvoiceDetailsResult>(`${apiUriInvoice}`, parameter);
    return result;
}

export async function getShippingTracking(parameter: ShippingTrackingApi) {
    const result = await get<ShippingTrackingResult>(`${apiTrackingUri}`, parameter);
    return result;
}

export function sendPackingSlipEmail(parameter: DanaSendPayslipEmailApiParameter) {
    return post<DanaSendPayslipEmailApiParameter>(`${apipacking}`, parameter);
}

export function sendInvoiceTypeEmail(parameter: DanaSendInvoiceTypeEmailApiParameter) {
    return post<DanaSendInvoiceTypeEmailApiParameter>(`${apiInvoiceEmail}`, parameter);
}

export function sendOrderDetailsEmail(parameter: DanaSendOrderDetailsEmailApiParameter) {
    return post<DanaSendOrderDetailsEmailApiParameter>(`${apiOrderDetailsEmail}`, parameter);
}
export async function getOpensOrders(parameter: OpenOrdersApiParameter) {
    const result = await get<BackorderResponse>(`${apiOpenorder}`, parameter);
    return result;
}

export async function getOpensOrdersDetails(parameter: OpenOrdersDetailsApiParameter) {
    const result = await get<CancelValidationResponse>(`${apiOpenorderDetail}`, parameter);
    return result;
}

export function PostCancelLines(parameter: PostCancelLinesApiParameter): Promise<any> {
    return post<PostCancelLinesApiParameter>(`${apiCancelLines}`, parameter);
}

export async function exportOpenOrders(customerNumber: string): Promise<boolean> {
    const result = await fetch(apiExportOpenOrder, {cache: "no-cache"});
    if (result.ok) {
        const file = await result.blob()
        let a = document.createElement("a");
        a.href = URL.createObjectURL(file);
        const formattedDate = formatDateForFilename(new Date());
        a.setAttribute("download", `OpenOrders_${customerNumber}_${formattedDate}.xlsx`);
        a.click();
        return true;
    }
    return false;
}

export async function getDeliveryNumbers(parameter: GetDeliveryNumberApiParameter): Promise<any> {
    const result = await get<any>(`${apideliveryNum}`, parameter);   
    return result;
}

export async function resubmitOrderNumberToErp(parameter: ResubmitOrderApiParameter): Promise<any> {
    const result = await get<string>(`${apiResubmitOrder}`, parameter);
    return result;
}

export function ordersRemoved(parameter: RemovedOrdesApiParameter): Promise<any> {
    return post<RemovedOrdesApiParameter>(`${apiordersRemoved}`, parameter);
}

export function ordersmovedFailed(parameter: MovedOrdesFailedApiParameter): Promise<any> {
    return post<MovedOrdesFailedApiParameter>(`${apiordersFailedRemoved}`, parameter);
}